/* PANDI CRO Section/Block Tracking v1 (2026-06-04) — events to existing GA4 gtag G-V17FTRVF11. No GTM. Reversible: delete this asset + the loader line in theme.liquid. */
(function () {
  if (window.__pandiCRO) return;
  window.__pandiCRO = true;
  function send(name, params) {
    params = params || {};
    params.device = (window.innerWidth < 768) ? 'mobile' : 'desktop';
    params.page_type = pageType();
    if (typeof window.gtag === 'function') { window.gtag('event', name, params); }
    else { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params)); }
  }
  function pageType() {
    var p = location.pathname;
    if (p === '/' || p === '') return 'home';
    if (p.indexOf('/products/') === 0) return 'product';
    if (p.indexOf('/collections/') === 0) return 'collection';
    if (p.indexOf('/cart') === 0) return 'cart';
    if (p.indexOf('/pages/') === 0) return 'page';
    return 'other';
  }
  var SECTION_MAP = { ph3_header:'HP_00_Header', ph3_hero:'HP_01_Hero', ph3_categories:'HP_02_CategoryGrid', ph3_ofertas:'HP_03_Ofertas', ph3_bestsellers:'HP_04_BestSellers', ph3_colchones:'HP_05_Colchones', ph3_premium:'HP_06_Premium', ph3_why:'HP_07_WhyPANDI', ph3_comparison:'HP_08_Comparison', loox_video_slider:'HP_09_LooxVideo', tolstoy_carousel:'HP_10_Tolstoy', ph3_reviews:'HP_11_Reviews', ph3_faq:'HP_12_FAQ', ph3_cart_drawer:'CART_00_Drawer' };
  function sectionName(el) {
    var s = el && el.closest ? el.closest('[id^="shopify-section"]') : null;
    if (!s) return 'unknown';
    var id = s.id.replace('shopify-section-', '');
    var token = id.indexOf('__') > -1 ? id.split('__').pop() : id;
    return SECTION_MAP[token] || token;
  }
  function productFrom(el) {
    var card = el.closest('[data-product-id],[data-product-handle],a[href*="/products/"]');
    var out = {};
    if (card) {
      out.product_id = card.getAttribute('data-product-id') || '';
      var a = card.matches('a[href*="/products/"]') ? card : (card.querySelector && card.querySelector('a[href*="/products/"]'));
      var href = a ? a.getAttribute('href') : '';
      var m = href && href.match(/\/products\/([^/?#]+)/);
      if (m) out.block_name = m[1];
    }
    return out;
  }
  try {
    var seen = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio >= 0.5) {
          var name = sectionName(e.target);
          if (!seen[name]) { seen[name] = 1; send('section_view', { section_name: name }); }
        }
      });
    }, { threshold: [0.5] });
    document.querySelectorAll('[id^="shopify-section"]').forEach(function (s) { io.observe(s); });
  } catch (x) {}
  document.addEventListener('click', function (ev) {
    var t = ev.target.closest('a,button,[role="button"],summary,input[type="radio"]');
    if (!t) return;
    var sec = sectionName(t);
    var txt = (t.textContent || t.value || '').trim().slice(0, 60);
    var href = (t.getAttribute && t.getAttribute('href')) || '';
    if (/wa\.me|api\.whatsapp|whatsapp/i.test(href) || /whatsapp/i.test(t.className)) { return send('whatsapp_click', { section_name: sec, block_name: txt }); }
    if (t.matches('[name="add"], .add-to-cart, [data-add-to-cart]') || (t.type === 'submit' && t.closest('form[action*="/cart/add"]'))) { return send('add_to_cart_click', Object.assign({ section_name: sec }, productFrom(t))); }
    if (t.closest('.shopify-payment-button') || /buy_now|comprar ahora/i.test(t.className + ' ' + txt)) { return send('buy_now_click', Object.assign({ section_name: sec }, productFrom(t))); }
    if (t.matches('[name="checkout"], [href*="/checkout"], .cart__checkout')) { return send('checkout_click', { section_name: sec }); }
    if (href.indexOf('/products/') > -1) { return send('product_card_click', Object.assign({ section_name: sec }, productFrom(t))); }
    if (sec === 'HP_10_Tolstoy' || /tolstoy/i.test(t.className)) { return send('tolstoy_click', { section_name: sec }); }
    if (sec === 'HP_11_Reviews' || sec === 'HP_09_LooxVideo' || /loox/i.test(t.className)) { return send('loox_click', { section_name: sec }); }
    if (t.tagName === 'SUMMARY' || t.matches('.accordion__title, [data-accordion]')) { return send('accordion_open', { section_name: sec, block_name: txt }); }
    if (t.matches('input[type="radio"][name*="option"], [data-variant], .product-form__input input')) { return send('variant_select', Object.assign({ section_name: sec, block_name: txt }, productFrom(t))); }
    if (sec === 'HP_01_Hero') { return send('hero_cta_click', { section_name: sec, block_name: txt }); }
    if (sec === 'HP_02_CategoryGrid') { return send('category_card_click', { section_name: sec, block_name: txt }); }
    if (sec === 'HP_04_BestSellers') { return send('best_seller_click', { section_name: sec, block_name: txt }); }
  }, true);
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (f && /newsletter|flashy|popup|subscribe/i.test((f.className || '') + ' ' + (f.id || ''))) { send('newsletter_submit', { section_name: sectionName(f) }); }
  }, true);
})();
